// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"283":"f5933448","455":"49ca68a6","529":"e7725b0f","552":"7b5e2c2c"}[chunkId] + ".chunk.css";
};